window.dataLayer = window.dataLayer || [];
export function reportData(event, data) {
  data = data || {};
  dataLayer.push({
    event: event,
    ...data,
  });
}
